const AUDIT_UA_PATTERNS = [
  /Chrome-Lighthouse/i,
  /Lighthouse/i,
  /Page[\s-]?Speed/i,
  /Speed Insights/i,
  /PTST/i, // Synthetic test agents such as Pingdom
];

export const isAuditUserAgent = (userAgent?: string | null): boolean => {
  if (!userAgent) return false;
  return AUDIT_UA_PATTERNS.some((pattern) => pattern.test(userAgent));
};

export const isAutomatedAuditRuntime = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return isAuditUserAgent(navigator.userAgent);
};

export default isAutomatedAuditRuntime;

